export default {"src":"/_next/static/media/Phone.e2164f91.svg","height":20,"width":20};